import React, { Component } from 'react'
import { compose } from 'recompose'
import { meta } from 'helpers/decorators'
import { Title } from '../../../components/layout'
import { NewPages } from '../../forms/orb-lab'
import { newPages } from '../../../constants/links/orb-lab'

const enhance = compose(
  meta({
    title: 'ORB Lab',
    intlKey: 'pageTitle.orbLab'
  })
)

class OrbLab extends Component {
  static propTypes = {
  }

  render() {
      const isTestUser = true // TODO security

      if (!isTestUser) {
        return (
          <div>
            <Title h2 intlKey="moduleTitle.forbidden">
              Forbidden
            </Title>
          </div>
        )
      }

    return (
      <div>
        <NewPages {...this.props} links={newPages} />
      </div>
    )
  }
}

export default enhance(OrbLab)
